<template>
    <div class="dbox">
        <div class="form-group">
            <TextField
                :id="'account_holder'"
                v-bind="textFieldConfig"
                :value="formsData.account_holder"  
                :placeholder="$t('account_holder')"
                @valuechanged="onTextFieldValueChange"
            />
            <TextField
                :id="'account_no'"
                v-bind="textFieldConfig"
                :value="formsData.account_no"
                :placeholder="$t('account_no')"
                @valuechanged="onTextFieldValueChange"
            />
            <TextField
                :id="'bank_name'"
                v-bind="textFieldConfig"
                :value="formsData.bank_name"
                :placeholder="$t('bank_name')"
                @valuechanged="onTextFieldValueChange"
            />
            <TextField
                :id="'sortcode'"
                v-bind="textFieldConfig"
                :value="formsData.sortcode"
                :placeholder="$t('sortcode')"
                @valuechanged="onTextFieldValueChange"
            />
        </div>
    </div>
</template>

<script>
    import TextField from "@plugins/text-field/text-field";
    import { EventHooks } from '../../../../plugins/text-field';
    import { format } from "date-fns";
    export default {
        components: {
            TextField,
        },
        props: ['formsData'],
        data() {
            return {
                textFieldConfig: {
                    height: 42,
                    showEditIconOnHover: false,
                    box: true,
                    showValidationIcons: false,
                    validationEvent: EventHooks.OnBlur,
                    valueChangedEvent: EventHooks.OnBlur,
                }
            }
        },
        methods: {
            onTextFieldValueChange: function(name, value) {
                this.$emit('changed', {name, value});
            },
        },
    }
</script>

<style lang="scss" scoped>
.form-group {
    padding-top: 4px;
    .dt-input-box--container {
        margin-right: 1px !important;
        margin-left: 0 !important;
    }
}
</style>